import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '../../organisms/navbar/navbar';
import { useRecoilState } from 'recoil';
import {
  Account_List,
  Current_User,
  Operating_System_State,
  Recoil_All_Accounts_Quarter_State,
  Recoil_Quarter_State,
  System_Date_Time_State,
} from '../../../recoil/recoil';
import { useEffect } from 'react';
import { getCurrentUser, getOldCurrentUser } from '../../../util/commonFunctions';
import {
  getAllRoleQuarterlyData,
  getOpportunitiesDue,
  getSystemDateTime,
  getUserRole,
} from '../../../services/commonServices';
import NoUserFoundModal from '../../organisms/modals/noUserFoundModal';
import PrivacyStatementModal from '../../organisms/modals/privacyStatementModal';
import { OPERATING_SYSTEM } from '../../../constants/commonConstants';

function Layout(props) {
  const [quarterData, setQuarterData] = useRecoilState(Recoil_Quarter_State);
  const [accountList, setAccountList] = useRecoilState(Account_List);
  const [currentUser, setCurrentUser] = useRecoilState(Current_User);
  const [allAccountsQuarterData, setAllAccountsQuarterData] = useRecoilState(
    Recoil_All_Accounts_Quarter_State,
  );
  const [systemDateTime, setSystemDateTime] = useRecoilState(System_Date_Time_State);
  const [isUserAvailable, setIsUserAvailable] = useState(null);
  const [osInfo, setOsInfo] = useRecoilState(Operating_System_State);

  let currentAssignedUser;
  let arrangedUserRoleDetails;
  let previouslySelectedUser;

  const GetCurrentSystemDateAPI = async () => {
    try {
      if (!!localStorage.getItem('modifiedSystemDateAndTime')) {
        setSystemDateTime(localStorage.getItem('modifiedSystemDateAndTime'));
        return localStorage.getItem('modifiedSystemDateAndTime');
      } else {
        const dateTime = await getSystemDateTime(localStorage.getItem('userEmail'));
        setSystemDateTime(dateTime?.date);
        return dateTime?.date;
      }
    } catch (error) {
      console.error('Error fetching SystemDateTime :', error);
    }
  };

  useEffect(async () => {
    if (!!localStorage.getItem('userEmail')) {
      let userRoleDetails = await getUserRole(localStorage.getItem('userEmail'));
      const getSystemDateTime = await GetCurrentSystemDateAPI();

      if (userRoleDetails.length != 0) {
        setIsUserAvailable(true);
        arrangedUserRoleDetails = userRoleDetails.sort((a, b) => a.priority - b.priority);

        setAccountList(arrangedUserRoleDetails);

        previouslySelectedUser = JSON.parse(localStorage.getItem('selectedUser'));
        if (!!localStorage.getItem('selectedUser')) {
          currentAssignedUser = getOldCurrentUser(previouslySelectedUser);
          setCurrentUser(currentAssignedUser);
        } else {
          currentAssignedUser = getCurrentUser(arrangedUserRoleDetails[0]);
          setCurrentUser(currentAssignedUser);
        }

        getOpportunitiesDue(
          currentAssignedUser.role,
          currentAssignedUser.email,
          getSystemDateTime.split('T')[0],
        )
          .then(result => {
            setQuarterData(result);
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });

        // To set all accounts quarter data
        getAllRoleQuarterlyData(currentAssignedUser.email, getSystemDateTime.split('T')[0])
          .then(result => {
            setAllAccountsQuarterData(result);
          })
          .catch(error => {
            console.error('Error fetching data:', error);
          });
      } else {
        setIsUserAvailable(false);
        console.log('******** USER NOT AUTHORISED ********');
      }
    }
  }, [localStorage.getItem('userEmail'), localStorage.getItem('selectedUser')]);

  useEffect(() => {
    const userAgent = window.navigator.userAgent;
    let osName = 'Unknown';

    if (userAgent.indexOf('Win') !== -1) {
      osName = OPERATING_SYSTEM.WINDOWS;
    } else if (userAgent.indexOf('Mac') !== -1) {
      osName = OPERATING_SYSTEM.MAC;
    } else if (userAgent.indexOf('Linux') !== -1) {
      osName = OPERATING_SYSTEM.LINUX;
    } else if (userAgent.indexOf('Android') !== -1) {
      osName = OPERATING_SYSTEM.ANDROID;
    } else if (userAgent.indexOf('iOS') !== -1) {
      osName = OPERATING_SYSTEM.IOS;
    }
    setOsInfo(osName);
  }, []);

  return (
    <>
      <Navbar></Navbar>
      {/* <Breadcrumb></Breadcrumb> */}
      <div style={{ width: '100%', height: '100%', paddingTop: '56px' }}>
        <div className="motif-container-fluid no-gutters">
          <Outlet />
          {!isUserAvailable && isUserAvailable != null && <NoUserFoundModal />}
          {isUserAvailable &&
            isUserAvailable != null &&
            !sessionStorage.getItem('isPrivacyPopupClosedOnce') && <PrivacyStatementModal />}
        </div>
      </div>
    </>
  );
}

export default Layout;
